import styled from 'styled-components'

export const CardInput = styled.div`
  padding: 8px 24px 16px;
  border: ${({ theme }) => `1px solid ${theme.ds.colors.neutral300}`};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Buttons = styled.div`
  display: flex;
  justify-content: right;
  gap: 20px;
  margin-top: 20px;

  button {
    width: 220px;
  }
`
